import { GlobalStatus, SaleStatusEnum, SoStatusEnum, StatusEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { SaleOrder } from "./sale-order.entitiy";

@Entity('so_transfer_log')
export class SOTransferLog {

  @PrimaryGeneratedColumn("increment", { name: 'so_transfer_log_id' })
  invoiceId: number;

  @Column("int", {
    nullable: false,
    name: "sale_order_id"
  })
  saleOrderId: number;

  @Column("int", {
    nullable: false,
    name: "from_unit"
  })
  fromUnit: number;

  @Column("int", {
    nullable: false,
    name: "to_unit"
  })
  toUnit: number;

  @Column("int", {
    nullable: true,
    name: "from_processing_unit"
  })
  fromProcessingUnit: number;

  @Column("int", {
    nullable: true,
    name: "to_processing_unit"
  })
  toProcessingUnit: number;

  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;



  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;



  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

}
